import {BZG_MODAL_DATA, BzgModalRef} from 'bz-genome-angular';
import {Component, Inject} from '@angular/core';


@Component({
  selector: 'resultErrorsModal',
  templateUrl: './result-errors.component.html'
})
export class ResultErrorsComponent  {
  constructor(public modalComponentRef: BzgModalRef, @Inject(BZG_MODAL_DATA) public data: {message: string, title: string}) { }

  close() {
    this.modalComponentRef.close();
  }
}
